import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";

type Column = { label: string; field: string };
type Props = {
  title: string;
  columns: Column[];
  data: any[];
  mt?: number;
};

const DashboardTable = ({ title, columns, data, mt = 0 }: Props) => (
  <Paper elevation={1} sx={{ p: 2, borderRadius: 1,mt:mt }}>
    <Typography variant="h6" gutterBottom>
      {title}
    </Typography>
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map((col, i) => (
              <TableCell key={i}>{col.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length > 0 ? (
            data.map((row, i) => (
              <TableRow key={i}>
                {columns.map((col, j) => (
                  <TableCell key={j}>{row[col.field] ?? "-"}</TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                No data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
);

export default DashboardTable;
